<mmp5-navbar [show]="false" [menu_items]="[]" [navbar_items]="navbar_items" [menu_toggle]="false" [hasPermissionToConfig]="true" [configUrl]="['/clients', 'crud']"></mmp5-navbar>
<div class="mmp-nav-margin">
  <router-outlet></router-outlet>
</div>